import React from 'react';
import { Typography } from '@mui/material';
import { useSerialStore } from '../stores/serialStore';

export const DeviceStatusIndicator: React.FC = () => {
  const isConnected = useSerialStore((state) => state.isConnected);

  return (
    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mt: 2 }}>
      Device: {isConnected ? 'Connected' : 'Disconnected'}
    </Typography>
  );
};
